import AnalyticsManager from "./analytics";

const analyticsInstance = AnalyticsManager.getInstance();

export default analyticsInstance;
